import { MaintainerConstants } from 'features/Maintainer/maintainerHelper';
import WizardStep from 'general/components/quybka/Wizards/WizardStep';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

MaintainerTicketWizardView.propTypes = {
    ticketItem: PropTypes.object,
};

function MaintainerTicketWizardView({
    ticketItem
}) {
    // MARK: ---- PROPERTIES ----
    const user = useSelector((state) => state.auth.user);
    const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const [currentStep, setCurrentStep] = useState(1);
    useEffect(() => {
        let step = 1;
        if (Utils.isValid(ticketItem)) {
            if ([
                MaintainerConstants.TicketStatus.CREATED,
                MaintainerConstants.TicketStatus.REJECTED,
            ].includes(ticketItem.status)) step = 2;
            else if (ticketItem?.status === MaintainerConstants.TicketStatus.TODO) step = 3;
            else if (ticketItem?.status === MaintainerConstants.TicketStatus.CHECKIN) step = 4;
            else if (ticketItem?.status === MaintainerConstants.TicketStatus.PENDING) step = 5;
            else if (ticketItem?.status === MaintainerConstants.TicketStatus.APPROVAL) step = 6;
            else if (ticketItem?.status === MaintainerConstants.TicketStatus.DONE) step = 7;
        }
        setCurrentStep(step);
    }, [ticketItem]);
    const wizardStepItems = useMemo(() => {
        let steps = [];
        steps = [
            {
                active: currentStep === 1,
                done: currentStep > 1,
                step: 1,
                title: currentStep > 1 ? 'Đã báo lỗi' : 'Báo lỗi',
                subTitle: 'Người dùng báo lỗi trụ sạc',
            },
            {
                active: currentStep === 2,
                done: currentStep > 2,
                step: 2,
                title:
                    currentStep > 2
                        ? 'Nhà điều hành đã phân phối công việc '
                        : currentStep === 2
                            ? 'Chờ nhà điều hành phân phối công việc'
                            : 'Nhà điều hành phân phối công việc ',
                subTitle: 'NĐH chuyển công việc vào danh sách tự nhận hoặc chỉ định người nhận',
            },
            {
                active: currentStep === 3,
                done: currentStep > 3,
                step: 3,
                title:
                    currentStep > 3
                        ? 'Đã check-in'
                        : currentStep === 3
                            ? 'Chờ check-in'
                            : 'Check-in',
                subTitle: 'KTV check-in tại trạm sạc',
            },
            {
                active: currentStep === 4,
                done: currentStep > 4,
                step: 4,
                title:
                    currentStep > 4
                        ? 'KTV đã kiểm tra và gửi yêu cầu xử lý'
                        : currentStep === 4
                            ? 'Chờ KTV kiểm tra và gửi yêu cầu xử lý'
                            : 'KTV kiểm tra và gửi yêu cầu xử lý',
                subTitle: 'KTV chụp ảnh, video hiện trường và mô tả hướng xử lý',
            },
            {
                active: currentStep === 5,
                done: currentStep > 5,
                step: 5,
                title:
                    currentStep > 5
                        ? 'NĐH đã duyệt yêu cầu xử lý'
                        : currentStep === 5
                            ? 'Chờ duyệt yêu cầu xử lý'
                            : 'Duyệt yêu cầu xử lý',
                subTitle: 'NĐH duyệt yêu cầu xử lý công việc',
            },
            {
                active: currentStep === 6,
                done: currentStep > 6,
                step: 6,
                title:
                    currentStep > 6
                        ? 'Đã hoàn thành'
                        : currentStep === 6
                            ? 'Chờ xác nhận hoàn thành'
                            : 'Hoàn thành',
                subTitle: 'KTV thực hiện bảo trì/sửa chữa; tải lên ảnh, video nghiệm thu và hóa đơn mua hàng (nếu có)',
            },
        ];
        return steps;
    }, [ticketItem, currentStep, isAdmin]);
    return (
        <div
            className="d-flex flex-row p-5 flex-wrap"
        >
            {wizardStepItems.map((stepItem, index) => {
                return (
                    <WizardStep
                        fill
                        key={index}
                        active={stepItem.active}
                        done={stepItem.done}
                        step={stepItem.step}
                        title={stepItem.title}
                        subTitle={stepItem.subTitle}
                        direction='vertical'
                        currentStep={currentStep}
                        isLast={stepItem.step == 6}
                    />
                );
            })}
        </div>
    );
}

export default MaintainerTicketWizardView;
